import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const Section = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter section"
      id="section"
      name="section"
      label="Section"
      data-testid="section"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default Section;
